import React from "react";
import {
  CheckBox,
  CheckBoxVariant,
  useMutationWrapper,
  showErrorDialog,
} from "@SeemplicityDev/shared";
import { showToast } from "../../../Forms/Dialogs/Toast/Toast";
import { CNC_UPDATE_ACTION } from "../ActionsAPI";
import {
  mutationOptionsType,
  updateActionMutationResponseType,
} from "../ActionsTypes";

const EnableActionToggle: React.FC<{
  accountUuid: string;
  actionId: string;
  displayName: string;
  enabled: boolean;
}> = ({ accountUuid, actionId, displayName, enabled }) => {
  const [updateAction, { loading }] = useMutationWrapper(CNC_UPDATE_ACTION, {
    refetchQueries: ["cncActions"],
    awaitRefetchQueries: true,
  }) as unknown as [
    (
      variables: mutationOptionsType
    ) => Promise<updateActionMutationResponseType>,
    { loading: boolean },
  ];

  const onChange = (newValue: boolean) => {
    updateAction({
      variables: {
        account_uuid: accountUuid,
        action_id: actionId,
        enabled: newValue,
      },
    })
      .then((res) => {
        showToast({
          message: `${displayName}\n was ${
            res?.data?.cnc_update_action?.action?.enabled
              ? "enabled"
              : "disabled"
          } successfully!` as any,
        });
      })
      .catch((err) => {
        showErrorDialog({ message: err.message });
      });
  };

  return (
    <CheckBox
      data-testid={`${actionId}_action_enable`}
      variant={CheckBoxVariant.TOGGLE}
      checked={enabled}
      isLoading={loading}
      onChange={(val: boolean, newValue: boolean) => onChange(newValue)}
      withTooltip={{
        content: enabled ? "Disable Action" : "Enable Action",
      }}
    ></CheckBox>
  );
};
export default EnableActionToggle;
